import { logErrorToSentry } from "../../../helpers/sentry";

export default {
  /**
   * Fetch sub-user balance by coin
   * @param {object} api - service from ApiService in local app
   * @param {string} coin - coin from coinService
   * @param {string} subId - sub user id
   *
   * @example
   * const api = ApiService.endpointApi
   * const coin = "btc";
   * const subId = "180778";
   *
   * await fetchSubUserCoinBalance({ api, coin });
   */
  async fetchSubUserCoinBalance({ commit }, { api, coin, subId }) {
    const isNotValidArguments = !api || !coin || !subId;

    if (isNotValidArguments) {
      throw new Error("fetchSubUserBalanceFromCoin: wrong arguments");
    }

    try {
      const amount = await api.get(`/profile/balance/${subId}/${coin}`);
      commit("SET_SUB_USER_COIN_BALANCE", { coin, amount, id: subId });
    } catch (e) {
      logErrorToSentry("fetchSubUserCoinBalance", "response.error", e);

      throw new Error(e);
    }
  },
};
